import React, { useEffect, useRef } from "react";
import {
  Card,
  Typography,
  Form,
  Input,
  // Select,
  Row,
  Col,
  Button,
  message,
  Spin,
  DatePicker,
} from "antd";
import dayjs from "dayjs";
import {
  BackwardOutlined,
  FormOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../api/Axios";
const { Title, Paragraph } = Typography;
const dateFormat = "MMM DD YYYY";
// const { Option } = Select;
const Summary = ({ data1, loading, LoadUser, ImpersonateAccess }) => {
  console.log(data1);
  const history = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const userInfo = useSelector((state) => state.user);
  const [messageApi, contextHolder] = message.useMessage();
  // const [tags, setTags] = useState([]);
  const CreateSuccessfull = (id) => {
    messageApi.open({
      type: "success",
      content: "Bundle edit success.",
      duration: 5,
    });
    LoadUser();
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Bundle edit failure",
      duration: 5,
    });
  };
  const formRef = useRef();
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleSubmit = async (values) => {
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const finalValues = {
      ...normalizedValues,
      organization: userInfo?.data?.organization?.id,
      due_date: values.due_date ? values.due_date.format("YYYY-MM-DD") : null,
      deactivate_on: values.deactivate_on
        ? values.deactivate_on.format("YYYY-MM-DD")
        : null,
    };

    console.log("Form submitted with values:", finalValues);
    try {
      const res = await axiosInstance.put(`learn/bundle/${id}/`, finalValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      CreateSuccessfull(res.data.id);
    } catch (err) {
      CreateFailed();
    }
  };
  const loadForm = React.useCallback(() => {
    if (!loading && formRef.current) {
      const formValues = {
        due_date: data1?.due_date ? dayjs(data1.due_date, "YYYY-MM-DD") : null,
        deactivate_on: data1?.deactivate_on
          ? dayjs(data1.deactivate_on, "YYYY-MM-DD")
          : null,
        name: data1?.name,
        bundle_id: data1?.bundle_id,
        description: data1?.description,
        tags: data1?.tags || [],
      };

      formRef.current.setFieldsValue(formValues);
    }
  }, [loading, data1]);

  const handleReset = () => {
    loadForm();
  };
  useEffect(() => {
    if (!loading && formRef.current) {
      loadForm();
    }
  }, [loading, data1, loadForm]);
  return (
    <Card
      style={{
        width: "100%",
        marginBottom: "10px",
      }}
      hoverable
    >
      <Spin spinning={loading}>
        {contextHolder}
        <Title level={4} style={{ letterSpacing: "0.5px" }}>
          Bundle Information
        </Title>
        <Paragraph type="secondary">
          Edit and configure your existing bundle with the details below
        </Paragraph>

        <Form
          layout="vertical"
          onFinish={handleSubmit}
          name="complex-form"
          ref={formRef}
          disabled={!ImpersonateAccess}
        >
          <Row gutter={16}>
            <Col span={9}>
              <Form.Item
                label="Bundle Name"
                required
                rules={[
                  {
                    required: true,
                    message: "name is required",
                  },
                ]}
                name="name"
              >
                <Input placeholder="Enter name" />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item
                label="Bundle ID"
                required
                rules={[
                  {
                    required: true,
                    message: "ID is required",
                  },
                ]}
                name="bundle_id"
              >
                <Input placeholder="Enter ID" />
              </Form.Item>
            </Col>

            {/* <Col span={9}>
              <Form.Item label="Tag" name="tags">
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  placeholder="Enter tags"
                  value={tags} // controlled value
                  onChange={setTags} // updates state when user adds/removes
                  tokenSeparators={[","]} // allow comma separation
                />
              </Form.Item>
            </Col> */}
          </Row>
          <Row gutter={16}>
            <Col span={9}>
              <Form.Item label="Due Date" name="due_date">
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%" }}
                  placeholder="Select Due Date"
                />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item label="Deactivation Date" name="deactivate_on">
                <DatePicker
                  format={dateFormat}
                  style={{ width: "100%" }}
                  placeholder="Select Deactivation Date"
                />
              </Form.Item>
            </Col>
          </Row>{" "}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Bundle Description" name="description">
                <Input.TextArea rows={4} placeholder="Enter description" />
              </Form.Item>
            </Col>
          </Row>
          <div
            className="group-1-box"
            style={{
              paddingTop: "0rem",
              paddingLeft: "0px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <div>
              <div style={{ display: "inline-block" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                    onClick={() => {
                      history(
                        isCAAdmin
                          ? "/ca-admin/trainery-learn/bundles/listing"
                          : "/trainery-learn/bundles/listing"
                      );
                    }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="save-update-btn"
                    // style={{
                    //   background: "#f58029",
                    // }}
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    onClick={handleReset}
                    style={{
                      background: "#D3D3D3",
                    }}
                  >
                    Reset
                    <RetweetOutlined />
                  </Button>
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </Spin>
    </Card>
  );
};

export default Summary;
